<template>
  <div class="model-select">
    <a-select :value="isLyPlayName" @change="changeIsPlayName" placeholder="请选择" style="max-width:700px;">
      <a-select-option :value="0">不需要游客信息</a-select-option>
      <a-select-option :value="1">仅需一人信息</a-select-option>
      <a-select-option :value="2">需要所有游客信息</a-select-option>
      <a-select-option v-if="catalogId==1" :value="3">一份多游客信息</a-select-option>
    </a-select>
    <div v-if="isLyPlayName!=0">
      <a-checkbox-group :value="optionLyTouristSelct" @change="changeCheckbox">
        <a-checkbox v-for="item in touristMessageList" :key="item.value" :value="item.value">{{ item.label }}
        </a-checkbox>
      </a-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TouristItem',
  props: {
    optionTouristSelct: {
      type: Array,
      default: []
    },
    isPlayName: {
      type: Number,
      default: 0
    },
    catalogId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLyPlayName: 0,
      optionLyTouristSelct: [],
      touristMessageList: [
        {
          label: '身份证号',
          value: '1'
        },
        {
          label: '护照',
          value: '2'
        },
        {
          label: '港澳通行证',
          value: '3'
        },
        {
          label: '台湾通行证',
          value: '4'
        },
        {
          label: '军官证',
          value: '5'
        },
        {
          label: '台胞证',
          value: '6'
        },
        {
          label: '回乡证',
          value: '7'
        },
        {
          label: '户口簿',
          value: '8'
        },
        {
          label: '出生证明',
          value: '9'
        }
      ]
    }
  },
  watch: {
    isPlayName(val) {
      this.isLyPlayName = val
    },
    optionTouristSelct(val) {
      this.optionLyTouristSelct = val
    }
  },
  mounted() {
    this.getLogUtils().logWithTag('catalogId--mounted', this.catalogId)
    this.isLyPlayName = this.isPlayName
    this.optionLyTouristSelct = this.optionTouristSelct
    if (this.catalogId == 73 || this.catalogId == 74) {
      let list = [{
        label: '手机号',
        value: '10'
      }]
      this.touristMessageList = [...this.touristMessageList, ...list]
    }
  },
  methods: {
    changeIsPlayName(value) {
      this.getLogUtils().logWithTag('changeIsPlayName', value)
      this.isLyPlayName = value
      if (value == 0) {
        this.optionLyTouristSelct = []
      }
      this.$emit('change', this.isLyPlayName)
    },
    changeCheckbox(value) {
      this.getLogUtils().logWithTag('changeCheckbox', value)
      this.optionLyTouristSelct = value
      this.$emit('selectChange', this.optionLyTouristSelct)
    }
  }

}
</script>
<style lang="less" scoped>

</style>